import { c as _c } from "react/compiler-runtime";
import { Hint } from '@systemeio/ui';
import { Rule } from 'modules/automation-rules/components/rule';
import { SpecificTriggerRulesProps } from 'modules/automation-rules/specific-trigger-rules';
import { AutomationRuleTriggersEnum } from 'modules/automation-rules/triggers/enums/trigger-enum';
import { AutomationRuleErrorInterface, AutomationRuleViewInterface } from 'modules/automation-rules/types/automation-rule-interface';
import React, { Dispatch, SetStateAction } from 'react';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import TransLoco from 'shared/components/trans-loco';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface SpecificTriggerRuleProps extends Pick<SpecificTriggerRulesProps, 'getRelatedAndUnrelatedTriggersData' | 'customAddTriggerHandler' | 'noRelatedMessage'> {
  tempState: AutomationRuleViewInterface;
  setTempState: Dispatch<SetStateAction<AutomationRuleViewInterface>>;
  errors: AutomationRuleErrorInterface;
  maxTriggerId: React.MutableRefObject<number>;
  maxActionId: React.MutableRefObject<number>;
  isPreFetching?: boolean;
  isFetching: boolean;
  savedTriggers?: AutomationRuleViewInterface['triggers'];
  ruleId?: number;
  availableTriggers?: AutomationRuleTriggersEnum[];
}
export function SpecificTriggerRule(props) {
  const $ = _c(26);
  const {
    t
  } = useLocoTranslation();
  let T0;
  let allowedTriggers;
  let t0;
  let t1;
  let t2;
  let unrelatedTriggers;
  if ($[0] !== props) {
    const {
      relatedTriggers: relatedSavedTriggers,
      unrelatedTriggers: t3
    } = props.getRelatedAndUnrelatedTriggersData(props.savedTriggers ?? []);
    unrelatedTriggers = t3;
    const {
      relatedTriggers: relatedTempTriggers
    } = props.getRelatedAndUnrelatedTriggersData(props.tempState.triggers);
    allowedTriggers = relatedSavedTriggers.map(_temp).concat(props.availableTriggers ?? []).filter(trigger_0 => !relatedTempTriggers.find(el => el.type === trigger_0));
    T0 = Rule;
    t0 = props;
    t1 = true;
    t2 = unrelatedTriggers.map(_temp2);
    $[0] = props;
    $[1] = T0;
    $[2] = allowedTriggers;
    $[3] = t0;
    $[4] = t1;
    $[5] = t2;
    $[6] = unrelatedTriggers;
  } else {
    T0 = $[1];
    allowedTriggers = $[2];
    t0 = $[3];
    t1 = $[4];
    t2 = $[5];
    unrelatedTriggers = $[6];
  }
  const t3 = props.customAddTriggerHandler;
  const t4 = !!props.ruleId && unrelatedTriggers.length !== 0;
  const t5 = props.ruleId ?? 0;
  let t6;
  if ($[7] !== props.noRelatedMessage || $[8] !== t5) {
    t6 = props.noRelatedMessage(t5);
    $[7] = props.noRelatedMessage;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t) {
    t7 = t("dashboard.automation_rule.trigger.title");
    $[10] = t;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t7) {
    t8 = <span className="text-text-primary text-[17px] font-bold">{t7}</span>;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t4 || $[15] !== t6 || $[16] !== t8) {
    t9 = <Hint showHint={t4} label={t6}>{t8}</Hint>;
    $[14] = t4;
    $[15] = t6;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== T0 || $[19] !== allowedTriggers || $[20] !== props.customAddTriggerHandler || $[21] !== t0 || $[22] !== t1 || $[23] !== t2 || $[24] !== t9) {
    t10 = <T0 {...t0} isStaticTriggers={t1} hideTriggers={t2} allowedTriggers={allowedTriggers} customAddTriggerHandler={t3} customTriggerTitle={t9} />;
    $[18] = T0;
    $[19] = allowedTriggers;
    $[20] = props.customAddTriggerHandler;
    $[21] = t0;
    $[22] = t1;
    $[23] = t2;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  return t10;
}
function _temp2(el_0) {
  return el_0.id;
}
function _temp(trigger) {
  return trigger.type;
}